import { render, staticRenderFns } from "./NoticeEdit.vue?vue&type=template&id=1f5246a1"
import script from "../../controllers/notice/notice-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/notice/notice-edit.js?vue&type=script&lang=js&external"
import style0 from "./NoticeEdit.vue?vue&type=style&index=0&id=1f5246a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports